import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-more\">\n<rect x=\"0.5\" y=\"0.5\" width=\"31\" height=\"31\" rx=\"2.5\" stroke=\"#D9D9D9\" />\n<path d=\"M8.14258 8.5H23.8591L18.0842 16.6812V23.5H13.9175V16.6812L8.14258 8.5ZM11.3591 10.1667L15.5842 16.1522V21.8333H16.4175V16.1522L20.6426 10.1667H11.3591Z\" fill=\"#232323\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol